// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3C08e","error":"Textarea_error__2YYBw","readonly":"Textarea_readonly__3_fbs","disabled":"Textarea_disabled__2xDfE"};